<template>
  <div class="comp-xl-date-picker">
    <template v-if="propData.name">
      <jw-radio-group type="button" v-model="state.dateQuickVal" :size="propData.size || 'small'" v-if="propData.customShow !== false && customList?.length" @change="qucikChange">
        <jw-radio :value="item" v-for="item in customList" :key="item">{{ getDayText(item) }}</jw-radio>
      </jw-radio-group>
      <template v-if="isCustom || width === 'fiexd'"> <jw-range-picker class="jw-date-self" :style="{ width: propData.width || '260px' }" :show-time="propData.showTime ?? false" :time-picker-props="state.timePickerProps" :disabled="propData.disabled ? true : false" v-model="state.dateVal" @change="datePickerChange" :allow-clear="propData.clearable === false ? false : true" :size="propData.size || 'small'" :format="propData.format || state.format" :shortcuts-position="pickerOptionPosition" :shortcuts="propData.pickerOption && pickerOptions" :trigger-props="{ updateAtScroll: true }" /> </template>
    </template>
    <template v-else>{{ $t('缺少参数') }}name</template>
  </div>
</template>

<script setup>
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { reactive, ref, computed, onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
dayjs.extend(quarterOfYear);

const props = defineProps({
  subcol: {
    type: Object,
    default() {
      return {};
    }
  },
  width: {
    type: String
  }
});
const emits = defineEmits(['cb', 'setDefault']);
// 默认值
const propData = computed(() => {
  const w = props.width;
  let c = props.subcol;
  if (w === 'fiexd') {
    c = Object.assign(
      { ...props.subcol },
      {
        customShow: false
      }
    );
  }
  return c;
});
// 获取自定义
const customList = computed(() => {
  if (props.subcol?.outCustomArray?.length) {
    return props.subcol?.outCustomArray;
  } else {
    return props.subcol?.customArray;
  }
});

const state = reactive({
  dateQuickVal: '7',
  dateVal: [],
  format: 'YYYY-MM-DD',
  timePickerProps: undefined
});
if (propData.value?.showTime) {
  state.format = 'YYYY-MM-DD HH:mm:ss';
  state.timePickerProps = { defaultValue: ['00:00:00', '23:59:59'] };
}
console.log(57, props, state);
// 单词转文字
const customSpecialObj = {
  year: t('本年度'),
  prevYear: t('上一年'),
  quarter: t('本季度'),
  prevQuarter: t('上一季度'),
  month: t('本月'),
  prevMonth: t('上月'),
  week: t('本周'),
  prevWeek: t('上周')
};
// 是否有自定义
const isCustom = computed(() => (propData.value?.customArray?.length && propData.value.customArray.find((el) => el == -1)) || !propData.value.customArray);
const pickerOptions = computed(() => {
  const shortcuts = [];
  propData.value.customArray.forEach((el) => {
    if (isNaN(Number(el)) === false || (typeof el === 'string' && customSpecialObj[el])) {
      const label = getDayText(el);
      const value = getDateSection(el);
      el != -1 && shortcuts.push({ label, value });
    }
  });
  return shortcuts;
});

// 快捷方式的位置
const pickerOptionPosition = computed(() => {
  let pos = 'left';
  const po = propData.value.pickerOptionPosition;
  if (po && po === 'right') pos = 'right';
  if (po && po === 'bottom') pos = 'bottom';
  return pos;
});
console.log(72, pickerOptions);
// 生成过去的天数和文本
const getDayText = (v) => {
  console.log(73, v, Number(v), isNaN(Number(v)));
  let ts = '';
  if (isNaN(Number(v)) === false) {
    if (v === 0) ts = t('今天');
    if (v === 1) ts = t('昨天');
    if (v > 1) ts = `${v}` + t('天');
    if (v === -1) ts = t('自定义');
  } else if (typeof v === 'string' && customSpecialObj[v]) {
    console.log(92, v, customSpecialObj);
    ts = customSpecialObj[v];
  }
  return ts;
};
// 获取默认时间
const getDefDate = () => {
  const v = propData.value.value;
  const isArray = Array.isArray(v);
  console.log(79, isArray, v);
  if (isArray) {
    state.dateQuickVal = -1;
    state.dateVal = v;
  } else if (v !== '' && (typeof v === 'string' || typeof v === 'number')) {
    let t = getDateSection(v);
    let val = -1;
    if (propData.value.customArray && propData.value.customArray.indexOf(v) > -1) {
      val = v;
      t = getDateSection(v);
    }
    console.log(78, val, t);
    state.dateQuickVal = val;
    state.dateVal = t;
  } else {
    state.dateQuickVal = -1;
    state.dateVal = [];
  }
};
//
//日期转换 返回为:2018-09-05  0为当前日期
const getyyyyMMdd = (a) => {
  console.log(126, a);
  var d;
  if (a == 0) {
    d = new Date();
  } else {
    // (typeof a == 'string') && (a = a.replace(/-/g,'/'))
    d = new Date(a);
  }
  var curr_date = d.getDate();
  var curr_month = d.getMonth() + 1;
  var curr_year = d.getFullYear();
  String(curr_month).length < 2 ? (curr_month = '0' + curr_month) : curr_month;
  String(curr_date).length < 2 ? (curr_date = '0' + curr_date) : curr_date;
  var yyyyMMdd = curr_year + '-' + curr_month + '-' + curr_date;
  return yyyyMMdd;
};
// 获取时间区间
const getDateSection = (v) => {
  // 是否包含今天
  const includeToday = propData.value.includeToday;
  const days = 3600 * 1000 * 24;
  const date = new Date(); // 今天
  let yesterday = new Date(); // 昨日
  yesterday = yesterday.setTime(date.getTime() - days); // 昨天
  yesterday = new Date(yesterday);
  let dateVal = [date, date];

  if (isNaN(Number(v)) === false) {
    if (v == 0) {
      dateVal = [date, date];
      console.log(1050, dateVal);
    } else if (v == 1 || v == -1) {
      dateVal = [yesterday, yesterday];
    } else {
      const end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - days * (v - 1));
      start = new Date(start);
      dateVal = [start, end];
      // 不包含今天
      if (!includeToday) {
        start = new Date();
        start.setTime(start.getTime() - days * v);
        start = new Date(start);
        dateVal = [start, yesterday];
      }
    }
    console.log(105, dateVal);
  } else if (typeof v === 'string' && customSpecialObj[v]) {
    console.log(174, 11111, v, dayjs().subtract(1, 'year'), (dayjs().quarter() - 1) * 3 + 1, customSpecialObj[v]);
    // 结束时间
    const endDate = !includeToday ? yesterday : date;
    // 季度
    const curQ = dayjs().quarter();
    const prevQ = dayjs().quarter() - 1;
    console.log('季度', curQ, prevQ);
    let sDate = `${new Date().getFullYear()}-${(dayjs().quarter() - 1) * 3 + 1}-01`;
    let eDate = endDate;
    const year = dayjs().format('YYYY');
    const m = new Date().getMonth();
    const d = new Date().getDate();
    const weekFirstDay = dayjs().day();

    let pqSm = `${(prevQ - 1) * 3 + 1}`;
    let pqEm = `${(prevQ - 1) * 3 + 3}`;
    if (prevQ === 0) {
      pqSm = 10;
      pqEm = 12;
    }
    switch (v) {
      case 'year':
        dateVal = [`${new Date().getFullYear()}-01-01`, endDate];
        break;
      case 'prevYear':
        dateVal = [`${dayjs().subtract(1, 'year').format('YYYY')}-01-01`, `${dayjs().subtract(1, 'year').format('YYYY')}-12-31`];
        break;
      case 'quarter':
        dateVal = [`${new Date().getFullYear()}-${(dayjs().quarter() - 1) * 3 + 1}-01`, endDate];
        break;
      case 'prevQuarter':
        pqSm = pqSm > 9 ? pqSm : `0${pqSm}`;
        pqEm = pqEm > 9 ? pqEm : `0${pqEm}`;
        sDate = `${new Date().getFullYear()}-${pqSm}-01`;
        eDate = `${new Date().getFullYear()}-${pqEm}-${new Date(new Date().getFullYear(), (prevQ - 1) * 3 + 3, 0).getDate()}`;
        if (prevQ === 0) {
          sDate = `${dayjs().subtract(1, 'year').format('YYYY')}-10-01`;
          eDate = `${dayjs().subtract(1, 'year').format('YYYY')}-12-31`;
        }
        dateVal = [sDate, eDate];
        break;
      case 'month':
        dateVal = [`${dayjs().format('YYYY-MM')}-01`, endDate];
        break;
      case 'prevMonth':
        console.log(211, year, m, d);
        dateVal = [`${dayjs().subtract(1, 'M').format('YYYY-MM')}-01`, `${dayjs().subtract(1, 'M').format('YYYY-MM')}-${new Date(year, m, 0).getDate()}`];
        break;
      case 'week':
        console.log(217, weekFirstDay, year, m, d);
        dateVal = [new Date(year, m, d - (weekFirstDay || 7) + 1), weekFirstDay === 1 ? new Date() : endDate];
        break;
      case 'prevWeek':
        dateVal = [new Date(year, m, d - (weekFirstDay || 7) - 7 + 1), new Date(year, m, d - (weekFirstDay || 7))];
        break;
      default:
        break;
    }
    // dateVal = [date, date];
    console.log(205, dateVal);
  }
  const ymd = dateVal.map((el) => getyyyyMMdd(el));
  console.log(206, ymd);
  return ymd;
};

watch(
  () => propData,
  (newVal) => {
    console.log('日期组件props变化', newVal);
    getDefDate();
    const o = ref({});
    o.value[propData.value.name] = state.dateVal;
    emits('setDefault', o.value);
  },
  { deep: true, immediate: true }
);

// 时间操作
const datePickerChange = (v) => {
  console.log(v);
  state.dateVal = v;
  // 如果选中的有值，则左侧也选中
  state.dateQuickVal = -1;
  // 触发事件
  emitEvent();
};

// 快捷操作事件
const qucikChange = (v) => {
  console.log(v);
  const t = getDateSection(v);
  state.dateVal = t;
  emitEvent();
};

// 监听事件
const emitEvent = () => {
  const o = ref({});
  o.value[propData.value.name] = state.dateVal;
  emits('cb', o.value);
};

// 获取默认时间
onMounted(() => {
  getDefDate();
});
</script>
<style scoped lang="less">
@import './xl-date-picker.less';
</style>
